import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: 10,
    marginTop: 20,
  },
}));
